module.exports = __webpack_public_path__ + "static/img/9.c0c2377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/9.png
// module id = bRxF
// module chunks = 2